import { FC, useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { GroupedCheckListDropdownMenu, useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export interface FollowUpReasonFilterTrayProps {
  disabled?: boolean;
  showClear?: boolean;
}

export const FollowUpReasonFilterTray: FC<FollowUpReasonFilterTrayProps> = ({ disabled, showClear = true }) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();

  const { getOptions } = useOptionsProvider();

  const isDisabled = disabled || isLoading;

  const onChange = useCallback(
    (value: CallIntelTypes.TaskType[]) => {
      updateFilterValues({ taskTypes: value });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ taskTypes: !!filterValues.taskTypes?.length });
  }, [filterValues.taskTypes, updateFilterModified]);

  return (
    <FilterTraySection
      label={t('Follow-up Reason')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <GroupedCheckListDropdownMenu
        name='follow-up-reasons'
        label={t('Select Follow-up Reasons')}
        placeholder={t('Select Follow-up Reasons')}
        onChange={onChange}
        groups={getOptions('taskType', 'groupedArray')}
        trackingIdBase={trackingIds.callIntel.followUpReasonsFilter}
        value={filterValues.taskTypes}
      />
    </FilterTraySection>
  );
};
